export function trackLead(eventName, params = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return;
  }

  window.gtag("event", eventName, {
    lead_type: eventName,
    page_path: window.location.pathname,
    page_location: window.location.href,
    ...params,
  });
}
